'use strict';
import $ from 'jquery';

export default class CustomerStories {
    static init() {
        $('.customer-stories').each((index, el) => {
            new CustomerStories($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.find('.customer-stories-stories').slick({
            mobileFirst: true,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: 'unslick'
                }
            ]
        })
    }
}